"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NO_DRAG_OFFSET = exports.NO_DRAG_OFFSET = { x: 0, y: 0 };

// New elements by default will be grabbed 3 grid units in from the top left
var DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS = exports.DEFAULT_NEW_ELEMENT_DRAG_OFFSET_GRID_UNITS = { x: 3, y: 3 };


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/dnd/dndConstants.js
// module id = 171
// module chunks = 0